import styled from "styled-components/native";
import { light_black } from "../../StyleHelpers";

export const Main = styled.View`
	z-index: -1;
	background-color: ${light_black};
	height: 100%;
`;

export const Container = styled.View<{ narrow?: boolean }>`
	padding: ${({ narrow }) => (narrow ? "6.5rem 8rem 1.5rem" : "7rem 24.25rem 3.5rem")};
	flex: 1;
	align-self: stretch;
	align-items: ${({ narrow }) => (narrow ? "flex-start" : "center")};
	gap: ${({ narrow }) => (narrow ? "1rem" : "0")};
`;

export const Content = styled.View`
	flex-direction: column;
	align-items: flex-start;
	flex: 1;
	align-self: stretch;
`;

export const Text = styled.Text<{ narrow?: boolean }>`
	font-size: ${({ narrow }) => (narrow ? "1.3125rem" : "1.5625rem")};
	color: white;
`;
